import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError, BaseResponse } from '@utils/types/shared/base';
import { GET_URL_NEW } from '@utils/api/endpoints';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params';

export interface WebhookCustomers {
  id: number;
  type: string;
  webhook_url: string;
  webhook_method: string;
  webhook_headers: string[];
  organization_id: number;
  created_at?: string;
  last_modified?: string;
}

export interface WebhookResponse extends BaseResponse<WebhookCustomers[]> {
  total_result?: number;
}

export const useGetWebhooks = (customerId: number) => {
  const { searchParams } = useNewAppSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;

  const sortField = (searchParams.sort as string | undefined) || undefined;
  const sortDirection =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;

  const qString = (searchParams.q as string | undefined) || undefined;

  const fetchWebhooks = async () => {
    const { customerWebhooksByCustomerId } = GET_URL_NEW({
      offset,
      limit,
      q: qString,
      sort: sortField,
      direction: sortDirection
    });

    const url = customerWebhooksByCustomerId(customerId);
    const { data } = await Axios.get<WebhookResponse>(url);
    return data;
  };

  return useQuery<WebhookResponse, AxiosError<BaseError>>(
    [
      'customerWebhooks',
      customerId,
      offset,
      limit,
      qString,
      sortField,
      sortDirection
    ],
    fetchWebhooks,
    {
      enabled: Number.isFinite(customerId) && customerId > 0,
      keepPreviousData: true,
      useErrorBoundary: false
    }
  );
};
